import { render, staticRenderFns } from "./StepNavigationWithScroll.vue?vue&type=template&id=712fd971"
import script from "./StepNavigationWithScroll.vue?vue&type=script&lang=js"
export * from "./StepNavigationWithScroll.vue?vue&type=script&lang=js"
import style0 from "./StepNavigationWithScroll.vue?vue&type=style&index=0&id=712fd971&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports